import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

import LearnUnitsDialog from './LearnUnitsDialog.jsx';

function LearnUnitsCell({ learnUnits }) {
  const [open, setOpen] = useState(false);
  const units = Array.isArray(learnUnits) ? learnUnits : [];

  if (units.length === 0) {
    return <span className='text-gray-400'>Sin unidad asociada</span>;
  }

  if (units.length === 1) {
    return <span>{units[0].name}</span>;
  }

  const remaining = units.length - 1;

  return (
    <>
      <Tooltip title='Clic para ver todas las unidades de aprendizaje' arrow>
        <span
          role='button'
          tabIndex={0}
          onClick={() => setOpen(true)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setOpen(true);
            }
          }}
          className='inline-flex items-center gap-1 whitespace-nowrap cursor-pointer hover:underline'>
          <span>{units[0].name} …</span>
          <span className='shrink-0 rounded-full bg-primary/10 text-primary text-xs font-medium px-1.5 py-0.5'>
            +{remaining}
          </span>
        </span>
      </Tooltip>
      <LearnUnitsDialog open={open} onClose={() => setOpen(false)} learnUnits={units} />
    </>
  );
}

export default LearnUnitsCell;
